import React from "react";
import { Stack, Typography, Chip, Box, Divider, Link as MuiLink } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { Link } from "react-router-dom";

const STATUS_STYLE = {
  active:    { label: "Active",    bg: "#dcfce7", fg: "#166534" },
  upcoming:  { label: "Upcoming",  bg: "#dbeafe", fg: "#1d4ed8" },
  completed: { label: "Completed", bg: "#e5e7eb", fg: "#374151" },
  archived:  { label: "Archived",  bg: "#e5e7eb", fg: "#374151" },
};

function seatsCaption(p) {
  if (p.available_seats != null) {
    return `Available: ${p.available_seats}`;
  }
  if (p.enrolled_count != null && p.enrolled_count > 0) {
    return `Enrolled: ${p.enrolled_count}`;
  }
  return null;
}

export default function CoursePlansList({ plans }) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle1" fontWeight={700} sx={{ color: "#111827" }}>Groups</Typography>
        <MuiLink
          component={Link}
          to="/admin/course-list"
          underline="hover"
          sx={{ color: "#7c3aed", fontSize: 13, fontWeight: 600 }}
        >
          View all
        </MuiLink>
      </Stack>

      {(!plans || plans.length === 0) ? (
        <Typography variant="body2" sx={{ color: "#374151" }}>No groups yet</Typography>
      ) : (
        <Stack divider={<Divider flexItem />} spacing={1}>
          {plans.slice(0, 3).map((p) => {
            const st = STATUS_STYLE[p.status] || STATUS_STYLE.completed;
            const planLabel = p.plan_name || p.name;
            const seats = seatsCaption(p);
            const subtitleParts = [
              p.academic_year,
              p.current_topic_label
                || (p.current_week ? `Week ${p.current_week} of ${p.total_weeks || 0}` : null),
              seats,
            ].filter(Boolean);
            return (
              <Stack key={p.id} direction="row" alignItems="center" spacing={1}>
                <Box
                  sx={{
                    width: 32, height: 32, borderRadius: 1,
                    bgcolor: "#ede9fe", color: "#7c3aed",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <DescriptionIcon sx={{ fontSize: 18 }} />
                </Box>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="body2" fontWeight={600} noWrap sx={{ color: "#111827" }}>
                    {planLabel}
                  </Typography>
                  {p.course_name && p.course_name !== planLabel && (
                    <Typography variant="caption" sx={{ color: "#374151", fontWeight: 700 }} noWrap display="block">
                      {p.course_name}
                    </Typography>
                  )}
                  <Typography variant="caption" color="text.secondary" noWrap display="block">
                    {subtitleParts.join(" · ") || "—"}
                  </Typography>
                </Box>
                <Chip
                  size="small"
                  label={st.label}
                  sx={{ bgcolor: st.bg, color: st.fg, fontWeight: 600 }}
                />
              </Stack>
            );
          })}
        </Stack>
      )}

      <Box mt={1.5} textAlign="left">
        <MuiLink
          component={Link}
          to="/admin/course-list"
          underline="hover"
          sx={{ color: "#7c3aed", fontSize: 13, fontWeight: 600 }}
        >
          View all groups
        </MuiLink>
      </Box>
    </Box>
  );
}
